/* global lazySizesConfig */
import lazysizes from 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

window.lazySizesConfig = window.lazySizesConfig || {}
lazySizesConfig.loadMode = 1
lazySizesConfig.loadHidden = false

lazysizes.init()
